export const SUBTITLE_CODE_403 = "Sorry, you don't have the access to this page.";
export const SUBTITLE_CODE_404 =
  "Oops! Sorry, the page you visited does not exist. Don't worry, let's get you back on track:";
export const BACK_HOME = 'Back Home';
